var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":_vm.t('view.title')}}),_c('exhibitor-scan')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }